const M = 256

export function newHll(): Uint8Array {
  return new Uint8Array(0)
}

export function hllDecode(hex: string): Uint8Array {
  return new Uint8Array(Buffer.from(hex, 'hex'))
}

export function computeOffset(filterFirstTagValue: string): number {
  let hex = filterFirstTagValue
  if (hex.length !== 64) {
    // Check if it's an address format "<kind>:<pubkey>:<d-tag>" per NIP-45
    const parts = hex.split(':')
    if (parts.length === 3 && parts[1] && parts[1].length === 64) {
      hex = parts[1]
    } else {
      // Non-standard input: default to offset 8
      return 8
    }
  }
  return parseInt(hex[32], 16) + 8
}

export function feedPubkey(hll: Uint8Array, pubkeyHex: string, offset: number): Uint8Array {
  const ri = parseInt(pubkeyHex.slice(offset * 2, offset * 2 + 2), 16)

  let leadingZeros = 0
  for (let i = offset + 1; i < 32; i++) {
    const byte = parseInt(pubkeyHex.slice(i * 2, i * 2 + 2), 16)
    if (byte === 0) {
      leadingZeros += 8
    } else {
      let mask = 0x80
      while ((byte & mask) === 0) {
        leadingZeros++
        mask >>= 1
      }
      break
    }
  }

  if (hll.length === 0) hll = new Uint8Array(M)
  const value = leadingZeros + 1
  if (value > hll[ri]) {
    hll[ri] = value
  }

  return hll
}

export function mergeHll(target: Uint8Array, source: Uint8Array): Uint8Array {
  if (target.length === 0) target = new Uint8Array(M)
  for (let i = 0; i < M; i++) {
    if (source[i] > target[i]) {
      target[i] = source[i]
    }
  }

  return target
}

export function estimateCount(hll: Uint8Array): number {
  if (hll.length === 0) return 0

  let V = 0
  let sum = 0
  for (let i = 0; i < M; i++) {
    if (hll[i] === 0) {
      V++
    }
    sum += 1 / (1 << hll[i])
  }

  if (sum === 0) return 0

  const alpha = 0.7213 / (1 + 1.079 / M)
  let estimate = (alpha * M * M) / sum

  if (estimate <= 2.5 * M && V > 0) {
    estimate = M * Math.log(M / V)
  }

  return Math.round(estimate)
}
